import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';

/**
 * This icon shouldn't be used for buttons.
 * In case you need clickable/hoverable color changing icon, use the IconButton component instead.
 * You CAN use it for showing tooltip on hover, but it shouldn't change it's styling on hover.
 * iconClass is the class name of the icon and should only identify the icon glyph.
 * @returns A span element with the icon.
 */
export const Icon = t0 => {
  const $ = _c(10);
  const {
    iconClass,
    color,
    "data-testid": dataTestId
  } = t0;
  let t1;
  if ($[0] !== iconClass) {
    t1 = classNames(iconClass, "w-[20px] h-[20px]");
    $[0] = iconClass;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== color) {
    t2 = {
      color
    };
    $[2] = color;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <i className={t1} style={t2} />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== dataTestId || $[8] !== t3) {
    t4 = <span className="inline-flex w-[24px] h-[24px] p-[2px]" data-testid={dataTestId}>{t3}</span>;
    $[7] = dataTestId;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};